import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-comp-wa-callout',
	templateUrl:'./WaCalloutPage.html',
	styles: [],
	styleUrls:['./WaCalloutPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WaCalloutPage
{
	mdContent_297 = `\`\`\`java
import com.jwebmp.webawesome.components.callout.WaCallout;
\`\`\``;
	mdContent_298 = `\`\`\`java
var callout = new WaCallout<>();
callout.setVariant(Variant.Warning);
callout.setText("This action is irreversible.");
\`\`\``;
}
